import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import utils from '../../utils/utils';

const AdminItemRow = ({ item, intl }) => {
  function deleteItem() {
    const confirmMessage = intl.formatMessage({ id: 'item.row.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      /*
      apiCalls
        .deleteItem({ itemId: item.id })
        .then(() => {
          // refresh
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
       */
    }
  }

  const imageStyle = item.images.length
    ? {
        backgroundImage: 'url(' + item.images[0].thumbnailImage + ')',
      }
    : {
        background: '#ccc',
      };

  const { formatMessage } = useIntl();

  return (
    <tr>
      <td scope="row">
        <Link to={`/admin/items/${item.id}`} className="link">
          <span className="admin__items-item-image d-inline-block m-r-1" style={imageStyle} />{' '}
          <span className={`align-self-center d-inline-block ${item.isPrivate ? 'text-muted' : ''}`}>
            #{item.id} {utils.getItemName(item, formatMessage)}{' '}
            {item.isPrivate ? (
              <small>
                <FormattedMessage id={'admin.items.table.name.is.private'} />
              </small>
            ) : (
              ''
            )}
          </span>
        </Link>
      </td>
      <td>
        <div>{item.priceFields.price}€</div>
      </td>
      <td>
        {item.marketplaces.length ? (
          <>
            <div>{item.marketplaces[0].marketplaceName}</div>
            {item.marketplaces[0].packingSection ? (
              <div>
                <small>
                  <FormattedMessage id={'admin.items.table.marketplace.packing.section'} />:{' '}
                  <strong>{item.marketplaces[0].packingSection}</strong>
                </small>
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          '-'
        )}
      </td>
      <td>
        <Link to={`/admin/items/edit/${item.id}`} className="link">
          <FormattedMessage id={'admin.items.table.actions.edit'} />
        </Link>
        <br />
        <button className="btn btn-normal-link d-none" onClick={deleteItem}>
          <FormattedMessage id={'admin.items.table.actions.delete'} />
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminItemRow.propTypes = {
  item: PropTypes.object.isRequired,
  getItems: PropTypes.func.isRequired,
};

AdminItemRow.defaultProps = {};

export default injectIntl(AdminItemRow);
